import axios from 'axios';
import { debounce } from 'lodash';
import firebase from '@firebase/app';
import '@firebase/auth';
import { SIGNUP_DEBOUNCE_DELAY } from '../../constants';

export const isDuplicatedEmail = async email => {
  const users = await axios.get('/company/user?email=' + email);
  const methods = await firebase.auth().fetchSignInMethodsForEmail(email);

  return users.data.total > 0 || methods.length > 0;
};

export const isDuplicatedEmailDebounced = (() => {
  const delay = SIGNUP_DEBOUNCE_DELAY;

  const debouncedFunction = debounce(async (resolve, reject, email) => {
    try {
      const isDuplicated = await isDuplicatedEmail(email);

      resolve(isDuplicated);
    } catch (error) {
      reject(error);
    }
  }, delay);

  return email => {
    return new Promise((resolve, reject) => {
      debouncedFunction(resolve, reject, email);
    });
  };
})();

export const isAdminEmail = email => {
  return email.includes('@supermembers.co.kr') || email.endsWith('@superchart.com');
};
